/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { SurfaceCompetitionResponse } from './SurfaceCompetitionResponse';
import {
    SurfaceCompetitionResponseFromJSON,
    SurfaceCompetitionResponseFromJSONTyped,
    SurfaceCompetitionResponseToJSON,
    SurfaceCompetitionResponseToJSONTyped,
} from './SurfaceCompetitionResponse';

/**
 * 
 * @export
 * @interface GetDropCompetitionsResponse
 */
export interface GetDropCompetitionsResponse {
    /**
     * 
     * @type {Array<SurfaceCompetitionResponse>}
     * @memberof GetDropCompetitionsResponse
     */
    competitions: Array<SurfaceCompetitionResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetDropCompetitionsResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the GetDropCompetitionsResponse interface.
 */
export function instanceOfGetDropCompetitionsResponse(value: object): value is GetDropCompetitionsResponse {
    if (!('competitions' in value) || value['competitions'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetDropCompetitionsResponseFromJSON(json: any): GetDropCompetitionsResponse {
    return GetDropCompetitionsResponseFromJSONTyped(json, false);
}

export function GetDropCompetitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDropCompetitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'competitions': ((json['competitions'] as Array<any>).map(SurfaceCompetitionResponseFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetDropCompetitionsResponseToJSON(json: any): GetDropCompetitionsResponse {
    return GetDropCompetitionsResponseToJSONTyped(json, false);
}

export function GetDropCompetitionsResponseToJSONTyped(value?: GetDropCompetitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitions': ((value['competitions'] as Array<any>).map(SurfaceCompetitionResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

